if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
                  qtyMinus = this.querySelector('.qty-minus'),
                  qtyPlus = this.querySelector('.qty-plus'),
                  qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
                  qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999,
                  qtyStep = qty.getAttribute('step') ? parseInt(qty.getAttribute('step')) : 1;

			if ( parseInt(qty.value) - qtyStep < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + qtyStep > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - qtyStep < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + qtyStep > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
            e.preventDefault();

              if ( qtyMinus.classList.contains('disabled') ) return;

               let currentQty = parseInt(qty.value);

               currentQty = Math.max(qtyMin, currentQty - qtyStep);

               qty.value = currentQty;

               qty.dispatchEvent(new Event('change', { bubbles: true }));

              qtyPlus.classList.remove('disabled');

             if ( currentQty <= qtyMin ) {
             qtyMinus.classList.add('disabled');
             }
            });

			qtyPlus.addEventListener('click', (e)=>{
            e.preventDefault();

              if ( qtyPlus.classList.contains('disabled') ) return;

             let currentQty = parseInt(qty.value);

             currentQty = currentQty + qtyStep;

             if ( currentQty > qtyMax ) {
              currentQty = qtyMax;
            }

             qty.value = currentQty;

             qty.dispatchEvent(new Event('change', { bubbles: true }));

             qtyMinus.classList.remove('disabled');

             if ( currentQty >= qtyMax ) {
             qtyPlus.classList.add('disabled');
             }
            });

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}